import { SET_USERLIST } from '../actions';

const userlist = (state = [], action) => {
  switch (action.type) {
	case SET_USERLIST:
      return [...action.value];  
    default: return state;
  }
}

export default userlist;
